var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 17.5H3.83333C3.36662 17.5 3.13327 17.5 2.95501 17.4092C2.79821 17.3293 2.67072 17.2018 2.59083 17.045C2.5 16.8667 2.5 16.6334 2.5 16.1667V3.83333C2.5 3.36662 2.5 3.13327 2.59083 2.95501C2.67072 2.79821 2.79821 2.67072 2.95501 2.59083C3.13327 2.5 3.36662 2.5 3.83333 2.5H6.16667C6.63338 2.5 6.86673 2.5 7.04499 2.59083C7.20179 2.67072 7.32928 2.79821 7.40917 2.95501C7.5 3.13327 7.5 3.36662 7.5 3.83333V5.83333M7.5 17.5H12.5M7.5 17.5L7.5 5.83333M7.5 5.83333H11.1667C11.6334 5.83333 11.8667 5.83333 12.045 5.92416C12.2018 6.00406 12.3293 6.13154 12.4092 6.28834C12.5 6.4666 12.5 6.69996 12.5 7.16667V17.5M12.5 9.16667H16.1667C16.6334 9.16667 16.8667 9.16667 17.045 9.25749C17.2018 9.33739 17.3293 9.46487 17.4092 9.62167C17.5 9.79993 17.5 10.0333 17.5 10.5V16.1667C17.5 16.6334 17.5 16.8667 17.4092 17.045C17.3293 17.2018 17.2018 17.3293 17.045 17.4092C16.8667 17.5 16.6334 17.5 16.1667 17.5H12.5",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.2d2d19458ddeaa5a8a684b24c2071240.svg";
export { ForwardRef as ReactComponent };